export default "__VITE_ASSET__i$zY5nR2__"